Object.defineProperty(exports, "__esModule", { value: true });
var math_1 = require("../utilities/math");
function computeDimensions(points) {
    var xmin = points[0];
    var ymin = points[1];
    var ymax = ymin;
    var xmax = xmin;
    for (var i = 2; i < points.length; i += 6) {
        var x = points[i + 4];
        var y = points[i + 5];
        xmin = math_1.min(xmin, x);
        xmax = math_1.max(xmax, x);
        ymin = math_1.min(ymin, y);
        ymax = math_1.max(ymax, y);
    }
    return {
        x: xmin,
        w: (xmax - xmin),
        y: ymin,
        h: (ymax - ymin)
    };
}
function computeAbsoluteOrigin(relativeX, relativeY, points) {
    var dimensions = computeDimensions(points);
    return {
        x: dimensions.x + dimensions.w * relativeX,
        y: dimensions.y + dimensions.h * relativeY
    };
}
exports.computeAbsoluteOrigin = computeAbsoluteOrigin;
